import'./EmailPassForm.css';
// import Submitbutton from '../container/emailPassModal'
// import Loginbutton from '../container/emailPassModal'
import { useState } from 'react';
import {
    auth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    } from '../config/firebase'
// import context from 'react-bootstrap/esm/AccordionContext';

const Signup=({Submitbutton , Loginbutton})=>{

    const [Name,setName] = useState('')
    const [Name2,setName2] = useState('')
    const [Sign,setSign] = useState('')
    const [SignPass,setSignPass] = useState('')
    const [Login,setLogin] = useState('')
    const [Loginpass,setLoginpass] = useState('')

    const RegUser=async()=>{

        await createUserWithEmailAndPassword(auth,Sign,SignPass)
            .then((userCredential) => {
                      const user = userCredential.user;
                      console.log(user);
                     
                    })
                    .catch((error) => {
                      // const errorCode = error.code;
                    //   console.log(errorCode);
                      const errorMessage = error.message;
                      console.log(errorMessage);
                    })
                    setName('')
                    setName2('')
                    setSign('')
                    setSignPass('')
    }
  

    const LoginUser=async()=>{

        await signInWithEmailAndPassword(auth,Login,Loginpass)
        .then((userCredential) => {
          const user = userCredential.user;
          console.log(user);
        })
        .catch((error) => {
          const errorCode = error.code;
          console.log(errorCode);
          // const errorMessage = error.message;
        })
        setLogin('')
        setLoginpass('')

}    
    return(
        <>
        <div className="modal-child2">

        <h1 className='loginHeading'>Let’s get started</h1>

        <div className="input_name">
         <input type="text" placeholder="First Name"
          value={Name}
         onChange={(e)=> setName(e.target.value)} className='name'/>   
         <input type="text" placeholder="Last Name" className='name'
         value={Name2} onChange={(e)=> setName2(e.target.value)}
         />   
        </div>

        <p style={{fontSize:'11px'}}>Enter your name as it appears on your driver’s license</p>

        <label>Email</label>
        <div >
         <input type="email"  placeholder="Email"  className="input_emailpass"
         value={Sign}
         onChange={(e)=> setSign(e.target.value)}
          />   
        </div><br/>

        <div >
            <label>Password</label>
         <input type="password"  placeholder="Password"  className="input_emailpass"
         value={SignPass} onChange={(e)=> setSignPass(e.target.value)}
          />  <br/>

         <input type="checkbox"/>
         <label className='firstRad'>I agree to the terms of service and privacy policy</label> <br/>
         <input type="checkbox"  className='secRad' />
         <label>Yes, send me deals, discounts, and updates!</label> 
        </div>
    
    <div className="reg" onClick={RegUser} >
        {Submitbutton }
    </div><br />

    <div className="or" style={{textAlign:'center',fontSize:'16px'}}>
        or
    </div>
    

    <div className="login">

        <div>
        <h1 className='loginHeading'>Already have an account</h1>
            <label htmlFor="">Email</label>
        <input type="text" placeholder='Email'   className="loginInput"
        value={Login}
        onChange={(e)=> setLogin(e.target.value)}
        />
        </div><br />

        <div >
        <label >Password</label>
        <input type="password" placeholder='Password' className="loginInput" 
        value={Loginpass}
        onChange={(e)=> setLoginpass(e.target.value)}
        />
        </div><br />

        <div className="reg"
         onClick={LoginUser}
         >
        {Loginbutton}
        </div>
        <p>This site is protected by reCAPTCHA and the Google <strong> Privacy Policy</strong> and <strong>Terms of Servic</strong> apply</p>
    </div>
        </div>
        </>
    )
}
export default Signup;